<template>
  <div class="c--referral_refer-now-referral new-container mx-auto">
    <div class="tw-container tw-mx-auto">
      <div class="get-in-touch tw-relative tw-shadow tw-rounded-lg tw-h-[408px]">
        <div class="tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0 tw-rounded-lg tw-z-10 tw-overflow-hidden">
          <nuxt-img
            src="/assets/images/referral/refer-now-referral.svg"
            width="1110"
            height="408"
            alt="refer-now-referral"
            loading="lazy"
            class="tw-h-full tw-object-contain tw-centered-xy"
          />
        </div>
        <div class="tw-relative tw-z-20 tw-h-full tw-w-full tw-flex tw-justify-center tw-items-center tw-px-7.5">
          <div class="tw-flex tw-flex-col tw-justify-center tw-items-center">
            <h2 class="tw-text-27 tw-font-semibold tw-mb-0 tw-text-center tw-tracking-tightest3x">
              {{ $t('components.refer.now.referral.title') }}
            </h2>

            <nuxt-link
              :to="localePath(link)"
              class="tw-text-11px tw-font-semibold tw-tracking-wide !tw-no-underline tw-text-center tw-bg-white hover:tw-bg-zinc-100 tw-text-primary hover:tw-text-primary tw-rounded tw-shadow tw-mt-5 tw-px-7.5 tw-py-[16.5px] tw-w-full"
            >
              {{ $t('components.referral.refer-now-button-title') }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'refer-now-referral',

    data() {
      return {
        link: '/profile/referral',
      }
    },
  }
</script>
